import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
    applicationAccept, applicationClose,
    applicationEscalate,
    applicationRedo,
    applicationReject,
    fetchApplication
} from "../redux/actions";
import {
    applicationSelector, authSelector,
    chapterSelector,
    rankSelector,
    recruitmentSelector,
    userSelector
} from "../redux/selectors";
import ApplicationDetail from "../Applications/ApplicationDetail";
import {openChapters, toArray, readableApplicationState} from "../common/util";
import RecruitmentApplicationForm from "./RecruitmentApplicationForm";
import Username from "../common/Username";
import Avatar from "../common/Avatar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faFlagCheckered, faCheck, faRedo, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Moment from 'react-moment';
import {hasGroup} from "../common/permissions";

class Recruitment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            chapter: openChapters(this.props.chapters)[1].id,
            application: { id: null, }
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {
        this.props.getApplication(this.props.match.params.id);
        document.title = "Addiction Gaming | Recruitment | Application #"+this.props.match.params.id
    }
    handleSubmit(values) {
        let submission = {
            reason: values.reason,
            action: values.button,
            state: this.props.applications[this.props.match.params.id].state,
        };
        console.log(submission);
        switch (values.button) {
            case 'escalate':
                this.props.escalateApplication(values.reason, this.props.match.params.id);
                break;
            case 'redo':
                this.props.redoApplication(values.reason, this.props.match.params.id);
                break;
            case 'accept':
                this.props.acceptApplication(values.reason, this.props.match.params.id);
                break;
            case 'reject':
                this.props.rejectApplication(values.reason, this.props.match.params.id);
                break;
            case 'close':
                this.props.closeApplication(values.reason, this.props.match.params.id);
                break;
            default:
                return null
        }
    }
    iconSwitch(action) {
        switch(action) {
            case 'submitted':
                return null;
            case 'approved':
                return <FontAwesomeIcon className="text-primary" icon={faCheck} fixedWidth />;
            case 'requested redo of':
                return <FontAwesomeIcon className="text-warning" icon={faRedo} fixedWidth />;
            case 'resubmitted':
                return null;
            case 'accepted on':
                return <FontAwesomeIcon className="text-primary" icon={faFlagCheckered} fixedWidth />;
            case 'rejected on':
                return <FontAwesomeIcon className="text-danger" icon={faTimes} fixedWidth />;
            case 'closed on':
                return <FontAwesomeIcon className="text-warning" icon={faTimesCircle} fixedWidth />;
            default:
                return null;
        }
    }

    render() {
        if (this.props.isAuthenticated) {
            return (
                <div>
                {toArray(this.props.applications)
                    .filter(application => application.id === Number(this.props.match.params.id))
                    .map((application, i) => (
                    <div key={application.id}>
                        <div className="panel-adt">
                            <h2>Application for {this.props.chapters[application.chapter].game.title}</h2>

                            <ul className="application-history-list">
                                {application.history.sort((a, b) => (new Date(a.created).getTime() - new Date(b.created).getTime())).map((history) => (
                                    <li key={history.id} className="application-history-item">
                                        <div className="clearfix">
                                            <div className="pull-left">
                                                <Avatar image={this.props.users[history.user].avatar} rank={this.props.ranks[this.props.users[history.user].rank]} width="24" height="24"/>
                                            </div>
                                            <span className="application-history-text">
                                                <Username user={this.props.users[history.user]} rank={this.props.ranks[this.props.users[history.user].rank]} />
                                                <span> {history.action}</span>
                                                <span className="application-history-highlight"> {readableApplicationState(history.state)} </span>
                                                <span>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip id="activity-feed-post-date"><Moment format="ddd MMM D YYYY">{history.created}</Moment></Tooltip>}>
                                                        <Moment fromNow>{history.created}</Moment>
                                                    </OverlayTrigger>
                                                </span>
                                            </span>
                                        </div>
                                        {history.action !== 'submitted' && history.action !== 'resubmitted' ? (
                                            <div className="application-history-icon">{this.iconSwitch(history.action)}
                                                <span> {history.reason}</span>
                                            </div>
                                        ) : ('')}
                                    </li>
                                ))}
                            </ul>
                            <h4><FontAwesomeIcon className="text-primary" icon={faArrowRight} fixedWidth /> {readableApplicationState(application.state)}</h4>
                        </div>
                        <ApplicationDetail application={application} auth={this.props.auth}/>
                        { hasGroup('Recruiter', this.props.auth.groups) || hasGroup('Interviewer', this.props.auth.groups) ? (
                        <div className="panel-adt">
                            <h3>Recruiter Controls</h3>
                            <RecruitmentApplicationForm auth={this.props.auth} onSubmit={this.handleSubmit} state={application.state} pending={this.props.recruitment.pending} />
                        </div>
                        ): ('')
                        }
                    </div>
                ))}
                </div>
            )
        } else {
            return (
                <Redirect to="/" />
            )
        }
    }
}

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.loggedIn,
    auth: authSelector(state),
    users: userSelector(state),
    ranks: rankSelector(state),
    chapters: chapterSelector(state),
    recruitment: recruitmentSelector(state),
    applications: applicationSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getApplication: (id) => dispatch(fetchApplication(id)),
    escalateApplication: (reason, id) => dispatch(applicationEscalate(reason, id)),
    redoApplication: (reason, id) => dispatch(applicationRedo(reason, id)),
    acceptApplication: (reason, id) => dispatch(applicationAccept(reason, id)),
    rejectApplication: (reason, id) => dispatch(applicationReject(reason, id)),
    closeApplication: (reason, id) => dispatch(applicationClose(reason, id)),

});

export default connect(mapStateToProps, mapDispatchToProps)(Recruitment);


// WEBPACK FOOTER //
// ./src/Recruitment/RecruitmentApplication.js